import {
  STORY_DOWNLOAD_URL_V2,
  MOMENT_DOWNLOAD_URL,
  ANNOTATED_MOMENT_DOWNLOAD_URL,
  PRINT_ORDER_URL
} from 'shared/utils/Constants';

import { get } from 'shared/services/ApiService';

export const downloadStory = (story, momentIds) => {
  let filename = 'download.zip';
  if (story.name) {
    filename = story.name.toLowerCase().replaceAll(/[^a-z0-9]/g, '-') + '.zip';
  }

  const url = STORY_DOWNLOAD_URL_V2(story.id, momentIds, filename);

  return downloadUrl(filename, url);
}

export const downloadUrl = (filename, url) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  return Promise.resolve();
}

export const downloadMomentBlob = (moment, includeAccessCode = false) => {
  let downloadUrl = MOMENT_DOWNLOAD_URL;
  if (includeAccessCode) {
    downloadUrl = ANNOTATED_MOMENT_DOWNLOAD_URL;
  }

  get(downloadUrl(moment.id))
    .then(resp => resp.blob())
    .then(blob => {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = `${moment.id}.jpg`;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
  )
}

export const downloadPrintOrder = (purchaseId) => {
  get(PRINT_ORDER_URL(purchaseId))
    .then(resp => resp.blob())
    .then(blob => {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = `${purchaseId}-print_order.csv`;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
  )
}
